module.exports = __webpack_public_path__ + "static/media/location.4b14c743.svg";